// Plain-English text for an error shown to a person (constitution §5.10). The API's own messages
// are written to be shown (constitution §4.11); anything else gets a fixed sentence, never a stack.
import { ApiError, NetworkError, UNEXPECTED_RESPONSE } from '@cis/api-client';

export const GENERIC_ERROR =
  'Something went wrong on this page. Try again. If it keeps happening, tell Arturo.';
export const NETWORK_ERROR = 'We could not reach the portal. Check your connection and try again.';

export function userMessage(err: unknown): string {
  if (err instanceof NetworkError) return NETWORK_ERROR;
  if (err instanceof ApiError && err.code !== UNEXPECTED_RESPONSE && err.message !== '') {
    return err.message;
  }
  return GENERIC_ERROR;
}
